import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { chartColorSets as t } from "@esri/calcite-colors";
import "../../intl.js";
import "../../core/has.js";
import { getLocale as s } from "../../intl/locale.js";
var n = "en-us",
    h = new Map([["ar", function () {
  return import("../../chunks/ar.js").then(function (t) {
    return t.a;
  });
}], ["bg-bg", function () {
  return import("../../chunks/bg_BG.js").then(function (t) {
    return t.b;
  });
}], ["bs-ba", function () {
  return import("../../chunks/bs_BA.js").then(function (t) {
    return t.b;
  });
}], ["ca-es", function () {
  return import("../../chunks/ca_ES.js").then(function (t) {
    return t.c;
  });
}], ["cs-cz", function () {
  return import("../../chunks/cs_CZ.js").then(function (t) {
    return t.c;
  });
}], ["da-dk", function () {
  return import("../../chunks/da_DK.js").then(function (t) {
    return t.d;
  });
}], ["de-de", function () {
  return import("../../chunks/de_DE.js").then(function (t) {
    return t.d;
  });
}], ["de-ch", function () {
  return import("../../chunks/de_CH.js").then(function (t) {
    return t.d;
  });
}], ["el-gr", function () {
  return import("../../chunks/el_GR.js").then(function (t) {
    return t.e;
  });
}], ["en-us", function () {
  return import("../../chunks/en_US.js").then(function (t) {
    return t.e;
  });
}], ["en-ca", function () {
  return import("../../chunks/en_CA.js").then(function (t) {
    return t.e;
  });
}], ["es-es", function () {
  return import("../../chunks/es_ES.js").then(function (t) {
    return t.e;
  });
}], ["et-ee", function () {
  return import("../../chunks/et_EE.js").then(function (t) {
    return t.e;
  });
}], ["fi-fi", function () {
  return import("../../chunks/fi_FI.js").then(function (t) {
    return t.f;
  });
}], ["fr-fr", function () {
  return import("../../chunks/fr_FR.js").then(function (t) {
    return t.f;
  });
}], ["he-il", function () {
  return import("../../chunks/he_IL.js").then(function (t) {
    return t.h;
  });
}], ["hr-hr", function () {
  return import("../../chunks/hr_HR.js").then(function (t) {
    return t.h;
  });
}], ["hu-hu", function () {
  return import("../../chunks/hu_HU.js").then(function (t) {
    return t.h;
  });
}], ["id-id", function () {
  return import("../../chunks/id_ID.js").then(function (t) {
    return t.i;
  });
}], ["it-it", function () {
  return import("../../chunks/it_IT.js").then(function (t) {
    return t.i;
  });
}], ["ja-jp", function () {
  return import("../../chunks/ja_JP.js").then(function (t) {
    return t.j;
  });
}], ["ko-kr", function () {
  return import("../../chunks/ko_KR.js").then(function (t) {
    return t.k;
  });
}], ["lt-lt", function () {
  return import("../../chunks/lt_LT.js").then(function (t) {
    return t.l;
  });
}], ["lv-lv", function () {
  return import("../../chunks/lv_LV.js").then(function (t) {
    return t.l;
  });
}], ["nb-no", function () {
  return import("../../chunks/nb_NO.js").then(function (t) {
    return t.n;
  });
}], ["nl-nl", function () {
  return import("../../chunks/nl_NL.js").then(function (t) {
    return t.n;
  });
}], ["pl-pl", function () {
  return import("../../chunks/pl_PL.js").then(function (t) {
    return t.p;
  });
}], ["pt-br", function () {
  return import("../../chunks/pt_BR.js").then(function (t) {
    return t.p;
  });
}], ["pt-pt", function () {
  return import("../../chunks/pt_PT.js").then(function (t) {
    return t.p;
  });
}], ["ro-ro", function () {
  return import("../../chunks/ro_RO.js").then(function (t) {
    return t.r;
  });
}], ["ru-ru", function () {
  return import("../../chunks/ru_RU.js").then(function (t) {
    return t.r;
  });
}], ["sk-sk", function () {
  return import("../../chunks/sk_SK.js").then(function (t) {
    return t.s;
  });
}], ["sl-sl", function () {
  return import("../../chunks/sl_SL.js").then(function (t) {
    return t.s;
  });
}], ["sr-rs", function () {
  return import("../../chunks/sr_RS.js").then(function (t) {
    return t.s;
  });
}], ["sv-se", function () {
  return import("../../chunks/sv_SE.js").then(function (t) {
    return t.s;
  });
}], ["th-th", function () {
  return import("../../chunks/th_TH.js").then(function (t) {
    return t.t;
  });
}], ["tr-tr", function () {
  return import("../../chunks/tr_TR.js").then(function (t) {
    return t.t;
  });
}], ["uk-ua", function () {
  return import("../../chunks/uk_UA.js").then(function (t) {
    return t.u;
  });
}], ["vi-vn", function () {
  return import("../../chunks/vi_VN.js").then(function (t) {
    return t.v;
  });
}], ["zh-cn", function () {
  return import("../../chunks/zh_Hans.js").then(function (t) {
    return t.z;
  });
}], ["zh-hk", function () {
  return import("../../chunks/zh_Hant.js").then(function (t) {
    return t.z;
  });
}], ["zh-tw", function () {
  return import("../../chunks/zh_Hant.js").then(function (t) {
    return t.z;
  });
}]]);

function e(t) {
  var s = t.split("-")[0].toLowerCase();
  var n = null;

  var _iterator = _createForOfIteratorHelper(h.keys()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _e = _step.value;

      if (_e.startsWith(s)) {
        n = _e;
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return n;
}

function r(t) {
  return t ? h.has(t.toLowerCase()) ? t.toLowerCase() : e(t) || n : n;
}

var o, i;

function c() {
  return _c.apply(this, arguments);
}

function _c() {
  _c = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var t,
        _yield$Promise$all,
        _yield$Promise$all2,
        _s,
        _n,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            t = _args.length > 0 && _args[0] !== undefined ? _args[0] : s();

            if (!(t = r(t), o && t === i)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", o);

          case 3:
            o = import("../../chunks/index.js").then(function (t) {
              return t.i;
            }), i = t;
            _context.prev = 4;
            _context.next = 7;
            return Promise.all([o, h.get(i)()]);

          case 7:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            _s = _yield$Promise$all2[0];
            _n = _yield$Promise$all2[1];
            i === t && (_s.am4core.options.defaultLocale = _n.default), _s.am4core.options.suppressWarnings = !0, _s.am4core.options.autoDispose = !0;
            _context.next = 17;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](4);
            return _context.abrupt("return", (o = null, i = null, null));

          case 17:
            return _context.abrupt("return", o);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 14]]);
  }));
  return _c.apply(this, arguments);
}

function u(s) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "default";
  var h = t.find(function (t) {
    return t.name === n;
  });
  return h ? h.colors.map(function (t) {
    return s.color(t);
  }) : null;
}

export { r as getChartLocale, u as getColorSet, c as loadChartsModule };